import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import '@geoapify/geocoder-autocomplete/styles/round-borders.css';
import './index.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createTheme, MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App.tsx';

const theme = createTheme({
  fontFamily: 'Host Grotesk, system-ui, sans-serif',
  headings: { fontFamily: 'Host Grotesk, system-ui, sans-serif' },
  defaultRadius: 'md',
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: Infinity, // Config is static per page load
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <MantineProvider theme={theme} forceColorScheme="light">
        <Notifications position="bottom-right" />
        <App />
      </MantineProvider>
    </QueryClientProvider>
  </StrictMode>,
);
